import { FC } from 'react'
import { Label } from '@entur/typography'
import { space } from '@entur/tokens'
import { ChoiceChip, ChoiceChipGroup } from '@entur/chip'

type TravelViewFieldProps = {
  travelView: string
  setTravelView: (travelView: string) => void
}
export const TravelViewField: FC<TravelViewFieldProps> = (props) => {
  const displayFlex = { display: 'flex', gap: space.rem.medium + 'rem' }

  return (
    <div>
      <Label>Reisevisning</Label>
      <div style={displayFlex}>
        <ChoiceChipGroup
          name="reisevisning"
          onChange={(e) => props.setTravelView(e.target.value)}
          value={props.travelView}
        >
          <ChoiceChip value={'normal'}>Normal</ChoiceChip>
          <ChoiceChip value={'tabell'}>Tabell</ChoiceChip>
        </ChoiceChipGroup>
      </div>
    </div>
  )
}
